import { SxProps, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = {
  color: string;
  sx?: SxProps
}

export default function CardStatus({ color, children, sx }: PropsWithChildren<Props>) {
  return (
    <Typography sx={sx}
      variant="subtitle1"
      display="flex"
      alignItems="center"
      color={color}
    >
      {children}
    </Typography>
  );
};